// extracted by mini-css-extract-plugin
export default {"card":"styles_card__XXJOz","heading":"styles_heading__wS99S","para":"styles_para__R8cH5","iconWrapper":"styles_iconWrapper__i4AWc"};